import { escapeRegExp } from 'lodash-es';

export const highlighter = (
  value: string,
  _highlight: string | string[] | null | undefined,
  matchWholeWords = false,
) => {
  if (_highlight == null) {
    return [{ chunk: value, highlighted: false }];
  }

  const highlight = Array.isArray(_highlight) ? _highlight.map(escapeRegExp) : escapeRegExp(_highlight);

  const shouldHighlight = Array.isArray(highlight)
    ? highlight.filter((part) => part.trim().length > 0).length > 0
    : highlight.trim() !== '';

  if (!shouldHighlight) {
    return [{ chunk: value, highlighted: false }];
  }

  const matcher =
    typeof highlight === 'string'
      ? highlight.trim()
      : highlight
          .filter((part) => part.trim().length !== 0)
          .map((part) => part.trim())
          .sort((a, b) => b.length - a.length)
          .join('|');

  const pattern = matchWholeWords ? `\\b(${matcher})\\b` : `(${matcher})`;
  const re = new RegExp(pattern, 'gi');

  const chunks = value
    .split(re)
    .map((part) => ({ chunk: part, highlighted: re.test(part) }))
    .filter(({ chunk }) => chunk);

  return chunks;
};
